import { render, staticRenderFns } from "./BulkRecords.vue?vue&type=template&id=8e56fd26"
import script from "./BulkRecords.vue?vue&type=script&lang=js"
export * from "./BulkRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports